import { render, staticRenderFns } from "./UpdateTransferTO.vue?vue&type=template&id=b0bc31f4&scoped=true&"
import script from "./UpdateTransferTO.vue?vue&type=script&lang=js&"
export * from "./UpdateTransferTO.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTransferTO.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UpdateTransferTO.vue?vue&type=style&index=1&id=b0bc31f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bc31f4",
  null
  
)

export default component.exports